import { RETENTION_CATEGORY, GENERIC_OFFER_CATEGORY, PRIVATE_CATEGORY } from "../constants/constants";

export const getCategory = (receivedCategory, mixedGenericCategories = false) => {
    if (!mixedGenericCategories) {
        return receivedCategory;
    }

    if (receivedCategory ===  PRIVATE_CATEGORY || receivedCategory === RETENTION_CATEGORY) {
        return GENERIC_OFFER_CATEGORY;
    }

    return receivedCategory;
}
